import getDefaultConfig from './getDefaultConfig.mjs';

function makeQuery(params, defaultAxiosInstance) {
  const { remote, options, axiosInstance, ...restParam } = params;
  const { key, queryFn } = getDefaultConfig({
    remote: remote(axiosInstance ?? defaultAxiosInstance),
    extraParams: "extraParams" in restParam ? restParam.extraParams : void 0
  });
  return {
    key,
    queryFn,
    options
  };
}

export { makeQuery as default };
//# sourceMappingURL=makeQuery.mjs.map
